<template>
  <div>
    <div class="top-menu">
      <div class="menu-area" style="">
        <div class="name-area">
          <router-link class="menu" :class="page_type === 'index' ? 'select' : ''" :to="{ name: 'Index' }">
            首页
          </router-link>
        </div>
      </div>
      <div class="menu-area">
        <div class="name-area">
          <router-link class="menu" :class="page_type === 'tutor_list' ? 'select' : ''" :to="{ name: 'TutorList' }">
            选课
          </router-link>
        </div>
      </div>
      <div class="menu-area">
        <div class="name-area">
          <router-link class="menu" :class="page_type === 'revealList' ? 'select' : ''" :to="{ name: 'RevealList' }">
            教员
          </router-link>
        </div>
      </div>
      <div class="menu-area">
        <div class="name-area">
          <router-link class="menu" :class="page_type === 'forum_list' ? 'select' : ''" :to="{ name: 'ForumList' }">
            论坛
          </router-link>
        </div>
      </div>
      <div class="menu-area">
        <div class="name-area">
          <router-link v-if="accountType == 'teacher'" class="menu" :class="page_type === 'my_center' ? 'select' : ''"
            :to="{ name: 'TeacherIndex' }">
            我的
          </router-link>
          <router-link v-else-if="accountType == 'user'" class="menu" :class="page_type === 'my_center' ? 'select' : ''"
            :to="{ name: 'UserIndex' }">
            我的
          </router-link>
          <router-link v-else class="menu" :to="{ name: 'UserLogin' }">
            登录
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainHeader',
  components: {
  },
  props: {
    page_type: {
      type: String,
      default: 'index'
    }
  },
  data() {
    return {
      accountType: undefined,
      nick_name: '',
      loginStatus: false
    }
  },
  computed: {
    region() {
      return this.$store.getters.region
    }
  },
  created() {
    this.accountType = this.$store.getters.accountType
    this.nick_name = this.$store.getters.userInfo.nick_name ? this.$store.getters.userInfo.nick_name : ''
    if (this.nick_name !== '') {
      this.loginStatus = true
    }
  },
  methods: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .top-menu {
    width: 100%;
    height: 44px;
    background-color: #ffffff;
    box-shadow: 1px 2px 5px 0px rgba(200, 200, 200, 0.24);

    .menu-area {
      float: left;
      width: 20%;
      height: 100%;
      text-align: center;

      .name-area {
        width: 48px;
        height: 100%;
        margin: auto;
        line-height: 44px

        .menu {
          display: inline-block;
          width: 48px;
          height: 44px;
          color: #333;
          font-weight: bold;
          font-family: PingFang-SC-Bold;
        }

        .select {
          border-bottom: 2px solid coral;
          border-radius: 2px;
          color: $theme-color;
        }
      }
    }
  }
</style>
